"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
// import inputMask from '@uswds/uswds/js/usa-input-mask';
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const __1 = require("..");
const util_1 = require("../../util");
const InputPrefix_1 = __importDefault(require("./InputPrefix/InputPrefix"));
const InputSuffix_1 = __importDefault(require("./InputSuffix/InputSuffix"));
const InputComponent = (0, react_1.forwardRef)(({ children, describedBy, error, id, inputWidth, 
// mask,
onChange, success, type = 'text', validationId, validators, value, ...props }, ref) => {
    const fieldRef = (0, react_1.useRef)(null);
    (0, react_1.useImperativeHandle)(ref, () => fieldRef.current);
    const groupClasses = (0, uswds_react_utils_1.createClassString)(error && 'usa-input-group--error', inputWidth && `usa-input-group--${inputWidth}`);
    const childComponents = (0, uswds_react_utils_1.flattenChildren)(react_1.Children.toArray(children));
    const labelEls = [];
    let prefixComponent;
    let suffixComponent;
    for (const child of childComponents) {
        const componentType = (0, react_1.isValidElement)(child) ? child?.type : undefined;
        switch (componentType) {
            case InputPrefix_1.default:
                prefixComponent = child;
                break;
            case InputSuffix_1.default:
                suffixComponent = child;
                break;
            default:
                labelEls.push(child);
        }
    }
    const hasPrefixOrSuffix = prefixComponent || suffixComponent;
    const classes = (0, uswds_react_utils_1.createClassString)(error && 'usa-input--error', success && 'usa-input--success', inputWidth && !hasPrefixOrSuffix && `usa-input--${inputWidth}`);
    const ariaDescribedBy = `${describedBy || ''} ${validationId || ''}`.trim() || undefined;
    const isTextArea = type === 'textarea';
    const inputEl = !isTextArea && ((0, jsx_runtime_1.jsx)("input", { ref: fieldRef, "aria-describedby": ariaDescribedBy, className: (0, uswds_react_utils_1.createClassString)('usa-input', classes
        // mask ? 'usa-masked' : ''
        ), "data-validation-element": validationId ? `#${validationId}` : undefined, id: id, name: id, onChange: onChange, 
        // pattern={
        //   mask?.pattern ||
        //   (props as React.InputHTMLAttributes<HTMLInputElement>)?.pattern ||
        //   undefined
        // }
        // placeholder={
        //   mask?.placeholder ||
        //   (props as React.InputHTMLAttributes<HTMLInputElement>)?.placeholder ||
        //   undefined
        // }
        type: type, value: value, ...(validators ? (0, util_1.validatorsToObject)(validators) : {}), ...props }));
    // useEffect(() => {
    //   const fieldEl = fieldRef.current;
    //   if (!fieldEl) return;
    //   if (mask && !isTextArea) {
    //     // call USWDS's `on` function to initialize the component
    //     inputMask.on(fieldEl);
    //     // on dismount, call USWDS's `off` function to cleanup the component
    //     return () => {
    //       inputMask.off(fieldEl);
    //     };
    //   }
    // }, []);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(__1.Label, { error: error, target: id, children: labelEls }), error && (0, jsx_runtime_1.jsx)(__1.FormError, { error: error }), isTextArea ? ((0, jsx_runtime_1.jsx)("textarea", { ref: fieldRef, "aria-describedby": ariaDescribedBy, className: (0, uswds_react_utils_1.createClassString)('usa-textarea', classes), id: id, name: id, onChange: onChange, value: value, ...props })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: hasPrefixOrSuffix ? ((0, jsx_runtime_1.jsxs)("div", { className: (0, uswds_react_utils_1.createClassString)('usa-input-group', groupClasses), children: [prefixComponent && (0, react_1.cloneElement)(prefixComponent), inputEl, suffixComponent && (0, react_1.cloneElement)(suffixComponent)] })) : (inputEl) }))] }));
});
const Input = Object.assign(InputComponent, {
    Prefix: InputPrefix_1.default,
    Suffix: InputSuffix_1.default
});
exports.default = Input;
